import { render, staticRenderFns } from "./SubscriptionSection.vue?vue&type=template&id=40ec2522&"
import script from "./SubscriptionSection.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports